import { GuidelineCategories } from 'consts/hiToolsConsts'
import CategoryAligners from './CategoryAligners'
import CategoryBraces from './CategoryBraces'
import CategoryTxGoals from './CategoryTxGoals'
import CategoryElastics from './CategoryElastics'
import CategoryIPR from './CategoryIPR'
import CategoryRPE from './CategoryRPE'
import CategoryOralHygiene from './CategoryOralHygiene'
import CategoryOther from './CategoryOther'

export default {
  [GuidelineCategories.AlignersTxTracking]: CategoryAligners,
  [GuidelineCategories.BracesTxTracking]: CategoryBraces,
  [GuidelineCategories.TxGoals]: CategoryTxGoals,
  [GuidelineCategories.Elastics]: CategoryElastics,
  [GuidelineCategories.IPR]: CategoryIPR,
  [GuidelineCategories.RPE]: CategoryRPE,
  [GuidelineCategories.OralHygiene]: CategoryOralHygiene,
  [GuidelineCategories.OtherAppliancesAndGuidelines]: CategoryOther
}
